import getters from './_getters';
import mutations from './_mutators';

const state = {
    emptyProject: {
        name: null,
        message: null,
        skill: null,
        student: null,
        customer: null,
        customerStatus: null,
    },

    step: null,
    project: null,
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
};



// WEBPACK FOOTER //
// ./src/taskflex/students/store/contactForm/index.js